import React from 'react';
import {StyleSheet, View, Dimensions, FlatList} from 'react-native';
import Styles from '../../Styles';
import AVText from 'src/components/elements/AVText';
import Localized from 'src/constants/AppStrings';
import {IsConnectedProps} from 'src/types/Screen';
import NearbyLocationView, {
  NearbyLocationType,
} from 'src/components/elements/home/NearbyLocationView';
import LocationErrorStatus, {
  LocationErrorStatusType,
} from 'src/components/elements/home/LocationErrorStatus';
import {getDescriber} from 'src/components/elements/home/descriptor/DescriptorType';
import Settings from 'src/Settings';
import LocationHandler from 'src/handlers/LocationHandler';
import NewNearbyLocationView from 'src/components/elements/home/NewNearbyLocationView';
import {getHeaderDescriber} from 'src/components/elements/headerDescriptor/DescriptorType';

type NearbyLocationsListProps = IsConnectedProps & {
  locations: NearbyLocationType[];
  mismatchLocationBalance: (value: boolean) => void;
};
const width = Dimensions.get('window').width;
const {getCampusLocationStyles, getNoNearbyLocationsComponent} = getDescriber();

const NearbyLocationsList = (props: NearbyLocationsListProps) => {
  //Returns Nearby Location Item UI
  const renderItem = ({item}) => {
    if (Settings.isRefiveAnd365Pay()) {
      return (
        <NearbyLocationView
          nearbyLocation={item}
          mismatchLocationBalance={props.mismatchLocationBalance}
        />
      );
    } else {
      return (
        <NewNearbyLocationView
          nearbyLocation={item}
          mismatchLocationBalance={props.mismatchLocationBalance}
          isOnlyTile={props.locations.length === 1}
        />
      );
    }
  };

  if (LocationHandler.isLocationPermissionEnabled === false) {
    return Settings.isRefiveAnd365Pay() ? (
      <LocationErrorStatus
        locationErrorStatusType={LocationErrorStatusType.LocationPermission}
      />
    ) : (
      getNoNearbyLocationsComponent(false)
    );
  }
  if (props.locations.length <= 0) {
    return Settings.isRefiveAnd365Pay() ? (
      <LocationErrorStatus
        locationErrorStatusType={LocationErrorStatusType.NoNearbyLocations}
      />
    ) : (
      getNoNearbyLocationsComponent(true)
    );
  }

  return (
    <View style={styles.containerView}>
      <View style={styles.header}>
        <AVText
          aria-label={`${Localized.Labels.near_by}, text`}
          style={[
            getCampusLocationStyles().descriptionText,
            styles.textHeader,
            getHeaderDescriber().subHeaderContainerStyleDescriptor()
              .subHeaderTextStyle,
          ]}
          accessibilityLabel={Localized.Labels.near_by}
          accessibilityRole="text"
          maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
          accessible={true}
        >
          {Localized.Labels.near_by}
        </AVText>
      </View>
      <FlatList
        horizontal={true}
        style={styles.locationListContainer}
        data={props.locations}
        showsHorizontalScrollIndicator={false}
        keyExtractor={(item) => item.campusId ?? item.locationId}
        renderItem={renderItem}
        ListHeaderComponent={<View style={styles.headerView} />}
        ListFooterComponent={<View style={styles.footerView} />}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  containerView: {
    alignItems: 'flex-start',
    marginRight: -Styles.Spacing.m3,
    marginLeft: -Styles.Spacing.m3,
    justifyContent: 'flex-start',
    marginVertical: Styles.Spacing.m3,
    marginTop: Styles.Spacing.m4,
  },
  locationListContainer: {
    width: '100%',
    marginLeft: -Styles.Spacing.m1,
  },
  header: {
    height: Styles.Heights.h3,
    width: width,
  },
  textHeader: {
    color: Styles.black,
    marginLeft: Styles.Spacing.m4,
  },
  headerView: {
    width: Styles.Spacing.m4,
  },
  footerView: {
    width: Styles.Spacing.m3 + Styles.Spacing.m2,
  },
});
export default NearbyLocationsList;
